import React, {PureComponent} from 'react';
import { withTranslation } from 'react-i18next';
import Input from "../../../components/UI/Input/Input";
import axios from "../../../axios-defaults";
import {toast} from "react-toastify";

class PersonnalInfos extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            editing: false,
            userInfos: props.userInfos,
            userAccount: props.userAccount,
            userAddress: props.userAddress,
            formIsValid: false,
            infosForm: {
                firstname: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'firstname',
                        autoComplete: 'firstname',
                        id: 'txt_firstname',
                    },
                    value: props.userInfos.firstname,
                    validationRules: {
                        required: true
                    },
                    valid: !!props.userInfos.firstname,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired"
                },
                lastname: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'lastname',
                        autoComplete: 'lastname',
                        id: 'txt_lastname',
                    },
                    value: props.userInfos.lastname,
                    validationRules: {
                        required: true
                    },
                    valid: !!props.userInfos.lastname,
                    visible: true,
                    touched: false,
                    errorMessages: {
                        required: "errors.fieldrequired"
                    },
                    errorMessage: "errors.fieldrequired"
                },
                telephone: {
                    elementType: 'input',
                    elementConfigs: {
                        type: 'text',
                        placeholder: '',
                        name: 'telephone',
                        autoComplete: 'telephone',
                        id: 'txt_lastname',
                    },
                    value: props.userInfos.telephone,
                    validationRules: {
                    },
                    valid: true,
                    visible: true,
                    touched: false
                }
            }
        }
    }

    checkValidity = (formElement,value,rules) => {
        let isValid = true;
        let errors = [];

        if(rules.required){
            const ruleValid = value.trim() !== ''
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.required))
            isValid = ruleValid && isValid;
        }

        if(rules.minLength){
            const ruleValid = value.length >= rules.minLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.minLength))
            isValid = ruleValid && isValid;
        }

        if(rules.maxLength){
            const ruleValid = value.length >= rules.maxLength
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.maxLength))
            isValid = value.length <= rules.maxLength && isValid;
        }

        if(rules.match){
            const ruleValid = this.state.passwordForm[rules.match].value === value
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.match))
            isValid = ruleValid && isValid;
        }

        if(rules.matchRegex){
            const ruleValid = value.match(rules.matchRegex) != null
            if (!ruleValid)
                errors.push(this.props.t(formElement.errorMessages.matchRegex))
            isValid = ruleValid && isValid;
        }

        return {valid:isValid,errorMessages:errors};
    }

    inputChangedHandler = (event, inputIdentifier) => {
        const updatedInfosForm = {...this.state.infosForm};
        const updatedFormElement = {...updatedInfosForm[inputIdentifier]}

        updatedFormElement.value = event.target.value;
        const validationResult = this.checkValidity(updatedFormElement, updatedFormElement.value, updatedFormElement.validationRules);
        updatedFormElement.valid = validationResult.valid
        if (validationResult.valid)
            updatedFormElement.errorMessage = "";
        else
            updatedFormElement.errorMessage = validationResult.errorMessages.join(', ');

        updatedFormElement.touched = true;

        updatedInfosForm[inputIdentifier] = updatedFormElement;

        let formIsValid = true;
        for(let inputIdentifier in updatedInfosForm){
            let inputValidity = updatedInfosForm[inputIdentifier].valid
            formIsValid = inputValidity && formIsValid;
        }

        this.setState({
            infosForm: updatedInfosForm,
            formIsValid: formIsValid
        });
    }

    editInfos = () => {
        this.setState({
            editing: !this.state.editing
        });
    }

    validateForm = () => {
        const updatedInfosForm = {...this.state.infosForm};
        let formIsValid = true;
        for(let inputIdentifier in updatedInfosForm){
            if (updatedInfosForm[inputIdentifier].elementConfigs.type == 'hidden')
                continue;

            const validationResult = this.checkValidity(updatedInfosForm[inputIdentifier], updatedInfosForm[inputIdentifier].value, updatedInfosForm[inputIdentifier].validationRules);
            if (!validationResult.valid){
                updatedInfosForm[inputIdentifier].valid = false;
                updatedInfosForm[inputIdentifier].touched = true;
                updatedInfosForm[inputIdentifier].errorMessage = validationResult.errorMessages.join(', ')
            }

            formIsValid = formIsValid && updatedInfosForm[inputIdentifier].valid;

        }

        this.setState({
            infosForm: updatedInfosForm,
            formIsValid: formIsValid
        });
    }

    saveInfos = (e) => {
        e.preventDefault();

        this.validateForm();

        if(!this.state.formIsValid){
            return false;
            toast.error(
                <div>
                    <i className="fal fa-exclamation-circle"></i>&nbsp;{this.props.t('profile.invalid_form')}
                </div>
            );
        }

        this.setState({loading:true});

        const {firstname,lastname,telephone} = this.state.infosForm;

        axios.put('/auth/update-profile-personnal-infos',
            {
                firstname : firstname.value,
                lastname : lastname.value,
                telephone : telephone.value
            })
            .then(response => {

                console.log('[PersonnalInfos.js] Edit Personnal Infos Ajax raw response',response);
                if(response.data.succeeded){
                    let successMessages = [];
                    {Object.keys(response.data.message).forEach(function (key) {
                        successMessages.push(response.data.message[key]);
                    })}

                    toast.success(
                        <div>
                            <i className="fal fa-check-circle"></i>&nbsp;{successMessages.join('\n\r')}
                        </div>
                    );
                    this.setState({
                        editing: false,
                        userInfos: {
                            firstname: this.state.infosForm.firstname.value,
                            lastname: this.state.infosForm.lastname.value,
                            telephone: this.state.infosForm.telephone.value
                        }
                    });
                }
                else{
                    let errorMessages = [];
                    {Object.keys(response.data.errors).forEach(function (key) {
                        errorMessages.push(response.data.errors[key][0]);
                    })}

                    toast.error(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{errorMessages.join('\n\r')}
                            </div>
                        </div>
                    );
                }
                this.setState({loading: false});
            }).catch(error => {
                if(error.response.data.errors){
                    let errorMessages = [];
                    {Object.keys(error.response.data.errors).forEach(function (key) {
                        errorMessages.push(error.response.data.errors[key][0]);
                    })}

                    toast.error(
                        <div>
                            <div>
                                <i className="fal fa-exclamation-circle"></i>&nbsp;{errorMessages.join('\n\r')}
                            </div>
                        </div>
                    );
                }

                this.setState({loading: false});
            }
        );
    }

    render() {

        let {
            userInfos,
            userAccount,
            userAddress
        } = this.state;

        return (
            <div>
                {this.state.editing?<p className={"alert alert-warning"}>{this.props.t("profile.editing_warning")}</p>:null}
                <div>
                    <div className="infos-box">
                        <strong className="infos-box__label">{this.props.t("profile.firstname")}</strong>
                        {!this.state.editing?
                            <div className="infos-box__value">{(userInfos.firstname) && userInfos.firstname}</div>
                            :
                            <Input key={this.state.infosForm.firstname.id}
                                   elementtype={this.state.infosForm.firstname.elementType}
                                   elementconfigs={this.state.infosForm.firstname.elementConfigs}
                                   value={this.state.infosForm.firstname.value}
                                   valid={this.state.infosForm.firstname.valid}
                                   shouldValidate={this.state.infosForm.firstname.validationRules}
                                   touched={this.state.infosForm.firstname.touched}
                                   changed={(event) => this.inputChangedHandler(event,this.state.infosForm.firstname.elementConfigs.name)}
                                   errorMessage={this.state.infosForm.firstname.errorMessage}/>}

                    </div>

                    <div className="infos-box">
                        <strong className="infos-box__label">{this.props.t("profile.lastname")}</strong>
                        {!this.state.editing?
                            <div className="infos-box__value">{(userInfos.lastname) && userInfos.lastname}</div>
                            :
                            <Input key={this.state.infosForm.lastname.id}
                                elementtype={this.state.infosForm.lastname.elementType}
                                elementconfigs={this.state.infosForm.lastname.elementConfigs}
                                value={this.state.infosForm.lastname.value}
                                valid={this.state.infosForm.lastname.valid}
                                shouldValidate={this.state.infosForm.lastname.validationRules}
                                touched={this.state.infosForm.lastname.touched}
                                changed={(event) => this.inputChangedHandler(event,this.state.infosForm.lastname.elementConfigs.name)}
                                errorMessage={this.state.infosForm.lastname.errorMessage}/>}
                    </div>

                    <div className="infos-box">
                        <strong className="infos-box__label">{this.props.t("profile.enterprise")}</strong>
                        <div className="infos-box__value">{(userAccount.name) && userAccount.name}</div>
                    </div>

                    <div className="infos-box">
                        <strong className="infos-box__label">{this.props.t("profile.phone")}</strong>
                        {!this.state.editing?
                            <div className="infos-box__value">{(userInfos.telephone) && userInfos.telephone}</div>
                            :
                            <Input key={this.state.infosForm.telephone.id}
                                   elementtype={this.state.infosForm.telephone.elementType}
                                   elementconfigs={this.state.infosForm.telephone.elementConfigs}
                                   value={this.state.infosForm.telephone.value}
                                   valid={this.state.infosForm.telephone.valid}
                                   shouldValidate={this.state.infosForm.telephone.validationRules}
                                   touched={this.state.infosForm.telephone.touched}
                                   changed={(event) => this.inputChangedHandler(event,this.state.infosForm.telephone.elementConfigs.name)}
                                   errorMessage={this.state.infosForm.telephone.errorMessage}/>}
                    </div>
                    <div className="infos-box">
                        <strong className="infos-box__label">{this.props.t("profile.address")}</strong>
                            <div className="infos-box__value">
                                {userAddress}
                            </div>
                    </div>
                </div>

                {this.state.editing?
                <div className="form__action">
                    <button type="submit" className="btn btn--outline" onClick={this.saveInfos}
                            disabled={!this.state.formIsValid?'disabled':''}>
                        {this.props.t("profile.savebtn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                    </button>
                    <button type="submit" className="btn btn--outline" onClick={this.editInfos}>
                        {this.props.t("profile.cancelbtn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                    </button>
                </div>:
                    <div className="form__action">
                        <button type="submit" className="btn btn--outline" onClick={this.editInfos}>
                            {this.props.t("profile.showformbtn")}&nbsp;&nbsp;<i className="fas fa-angle-right"></i>
                        </button>
                    </div>}
            </div>


        );
    }
}

export default withTranslation()(PersonnalInfos);

